import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number, currency = 'MYR'): string {
  return new Intl.NumberFormat('ms-MY', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(amount)
}

export function formatNumber(num: number): string {
  return new Intl.NumberFormat('ms-MY').format(num)
}

export function formatDate(date: Date | string): string {
  return new Intl.DateTimeFormat('ms-MY', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(date))
}

export function maskNRIC(nric: string): string {
  if (!nric || nric.length < 12) return nric
  return `${nric.slice(0, 6)}-**-${nric.slice(-4)}`
}
